import React, { FC, useContext } from 'react'
import EarningsRepartitionChart from '@/app/modules/p2c/reports/earnings/charts/EarningsRepartitionChart'
import EarningsEvolutionChart from '@/app/modules/p2c/reports/earnings/charts/EarningsEvolutionChart'
import { Card } from '@/components/Card'
import { DateRangeContext } from '@/components/context/DateRangeContext'
import { Customer } from '@/app/modules/p2c/customers/core/_models'

interface Props {
  customer?: Customer
}

const EarningsReportPane: FC<Props> = ({ customer }) => {
  const { from, to, timezone } = useContext(DateRangeContext)

  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          <EarningsRepartitionChart
            userId={customer?._id}
            from={from}
            to={to}
            timezone={timezone}
            height={200}
          />
        </div>
        <div className="col-xl-8">
          <Card
            title="Earnings evolution"
            collapsable={false}
          >
            <EarningsEvolutionChart
              userId={customer?._id}
              from={from}
              to={to}
              timezone={timezone}
              restock={customer === undefined}
              height={350}
            />
          </Card>
        </div>
      </div>
    </>
  )
}

export default EarningsReportPane
